import cn from "classnames";
import { type ButtonHTMLAttributes, forwardRef, type MouseEvent, memo } from "react";
import styles from "./MenuButton.module.css";

interface MenuButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    isActive?: boolean;
    className?: string;
}

export const MenuButton = memo(
    forwardRef<HTMLButtonElement, MenuButtonProps>(function MenuButton(
        { onClick, children, className, isActive = false, ...props },
        ref,
    ) {
        const buttonStyles = cn(styles.button, className, isActive && styles.active);

        const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
            if (onClick) {
                onClick(event);
            }

            event.currentTarget.blur();
        };

        return (
            <button
                className={buttonStyles}
                type="button"
                onClick={handleClick}
                ref={ref}
                {...props}
            >
                {children}
            </button>
        );
    }),
);

MenuButton.displayName = "MenuButton";
